<script>
import Vue from 'vue';
import DibbleTranslation from '../../translation/translation';
import VueRouter from 'vue-router';
import LoginEmailPassword from '@/components/Auth/subs/LoginEmailPassword.vue';
import LoginVerification from '@/components/Auth/subs/LoginVerification.vue';
import LoginOTP from '@/components/Auth/subs/LoginOTP.vue';
import RegisterStep1 from '@/components/Registration/subs/RegisterStep1.vue';
import RegisterStepper from '@/components/Registration/subs/RegisterStepper.vue';
import RegisterStep2 from '@/components/Registration/subs/RegisterStep2.vue';
import RegisterStep3 from '@/components/Registration/subs/RegisterStep3.vue';
import DibbleApi from '@/api';
import DibbleJS from '@/dibble';

Vue.use(require('vue-cookies'));
Vue.use(VueRouter);

export default {
    name: 'Registration',
    components: {
        RegisterStep3,
        RegisterStep2,
        RegisterStepper,
        RegisterStep1,
        LoginOTP,
        LoginVerification,
        LoginEmailPassword,
    },
    data() {
        return {
            translate: DibbleTranslation,
            errors: [],
            currentStep: 1,
            registrationData: {
                account_name: '',
                account_type: '1',
                first_name: '',
                last_name: '',
                email: '',
                password: '',
                re_password: '',
                phone_num: '',
                country_code: 'US',
                address1: '',
                address2: '',
                city: '',
                state: 'NY',
                zip: '',
                country: 'US',
                purpose: '',
            },
        };
    },
    methods: {
        submitRegistration() {
            DibbleJS.showLoader();
            const params = {
                '#request': DibbleApi.api.createAccount,
                ...this.registrationData,
            };
            DibbleJS.callApiRequest(params, (response) => {
                console.log('response', response);
                if (response.rc === 0) {
                    this.$cookies.set('_token', response.token, '365d');
                    this.$cookies.set(
                        '_user', response,
                        '365d'
                    );
                    window.location.href='/';
                } else {
                    DibbleJS.toastErrorMessage(response.message);
                }
                DibbleJS.hideLoader();
            });
        },
        setCurrentStep(step) {
            this.currentStep = step;
            this.setStepData(step);
        },
        stepperSubmit(data) {
            let isLastStep = false;
            this.registrationData = { ...this.registrationData, ...data };
            if (this.currentStep < 3) {
                this.currentStep++;
                this.setStepData(this.currentStep);
            } else {
                isLastStep = true;
            }

            if (this.currentStep === 3 && isLastStep) {
                this.submitRegistration();
            }
        },
        setStepData(step) {
            switch (step) {
                case 1:
                    this.$refs.step1Ref.setData(this.registrationData);
                    break;
                case 2:
                    this.$refs.step2Ref.setData(this.registrationData);
                    break;
                case 3:
                    this.$refs.step3Ref.setData(this.registrationData);
                    break;
            }
        },
    },
};
</script>
<template src="./template/index.html"></template>
<style>
.login-wrapper {
    background-color: #f8f8f8;
    font-size: 17px;
    color: #717171;
}

.registration-right-wrapper {
    background-image: url('~@/assets/images/bg-register.png');
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
}

.logo-wrapper {
    margin-block-end: 150px;
}
.Auth {
    color: #ffffff;
}
.login-form {
    inline-size: 100%;
    inline-size: calc(100% - 24px);
    max-inline-size: 580px;
    margin: 0 auto;
    background: white;
    padding: 40px 40px;
    box-shadow: 0 3px 9px 1px #e5e5e5;
    border-radius: 8px;
}

.description {
    opacity: 0.4;
}

.divider {
    background: #4a4a4a;
    block-size: 20px;
    margin-inline: 10px;
    min-inline-size: 1px;
    margin-top: 3px;
}

.login-logo {
    width: 250px;
}

.login-form .form-box {
    background: #e1e7e9 !important;
}
.toggle-view-password {
    right: 15px;
}
</style>
